import { usePermissions } from 'context/PermissionsContext';
import {
  CONFIG_SECTION_CODES,
} from 'permissions/constants/moduleKeyMap';

export const useMenuPermissions = () => {
  const {
    can,
    hasModuleAccess,
    hasAnyModuleAccess,
    hasAllModuleAccess,
    hasConfigSectionPermission,
  } = usePermissions();

  const canSeeMenuItem = (item) => {
    if (item.requiredModule && !hasModuleAccess(item.requiredModule))
      return false;

    if (
      Array.isArray(item.anyModules) &&
      item.anyModules.length > 0 &&
      !hasAnyModuleAccess(item.anyModules)
    )
      return false;

    if (
      Array.isArray(item.allModules) &&
      item.allModules.length > 0 &&
      !hasAllModuleAccess(item.allModules)
    )
      return false;

    if (typeof item.permission === 'number') return can(item.permission);

    if (Array.isArray(item.anyPermission))
      return item.anyPermission.some((p) => can(p));

    if (Array.isArray(item.children)) return item.children.some(canSeeMenuItem);

    return true;
  };

  const canSeeConfiguration =
    hasConfigSectionPermission(CONFIG_SECTION_CODES.CONFIG_SECTION);

  return { canSeeMenuItem, canSeeConfiguration };
};
